import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Grid, FormControl, FormHelperText } from '@mui/material';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import { addNewDepartment } from '../../API';

const ModalAddDepartment = ({ onClick, onDataAdd, departmentList }) => {
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [parentDepartment, setParentDepartment] = useState(null);
  const [codeError, setCodeError] = useState('');
  const [nameError, setNameError] = useState('');
  const [parentDepartmentError, setParentDepartmentError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const topLevelDepartments = (departmentList || []).filter((item) => !item.under_department_id);

  const handleAdd = async () => {
    setCodeError('');
    setNameError('');
    setParentDepartmentError('');
    setIsLoading(true);

    if (!code) {
      setCodeError('Kode harus diisi');
      setIsLoading(false);
      return;
    }
    if (!name) {
      setNameError('Nama harus diisi');
      setIsLoading(false);
      return;
    }

    const body = {
      code,
      name,
      under_department_id: parentDepartment?.id ?? null,
      is_active: 1,
    };

    try {
      const res = await addNewDepartment(body);
      if (res.meta.code === 201) {
        toast.success('Departemen berhasil ditambahkan.');
        onDataAdd();
        onClick();
      }
    } catch (error) {
      const errors = error.response?.data?.meta?.errors;
      if (errors) {
        if (errors.code) setCodeError(errors.code[0]);
        if (errors.name) setNameError(errors.name[0]);
        if (errors.under_department_id) setParentDepartmentError(errors.under_department_id[0]);
        Object.values(errors)
          .flat()
          .forEach((msg) => toast.error(msg));
      } else {
        toast.error('Gagal menambahkan departemen');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} lg={6}>
        <TextField
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
          id="outlined-required"
          label="Kode"
          fullWidth
          error={!!codeError}
          helperText={codeError}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <TextField
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          id="outlined-required"
          label="Nama"
          fullWidth
          error={!!nameError}
          helperText={nameError}
        />
      </Grid>
      <Grid item xs={12} lg={12}>
        <FormControl fullWidth error={!!parentDepartmentError}>
          <Autocomplete
            id="parent-department-autocomplete"
            options={topLevelDepartments}
            value={parentDepartment}
            onChange={(event, newValue) => setParentDepartment(newValue)}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField {...params} label="Departemen Induk (opsional)" error={!!parentDepartmentError} fullWidth />
            )}
          />
          {parentDepartmentError && <FormHelperText>{parentDepartmentError}</FormHelperText>}
        </FormControl>
      </Grid>

      <Grid item xs={12} lg={12}>
        <LoadingButton
          loading={isLoading}
          role="CircularProgress"
          color="color"
          variant="contained"
          fullWidth
          size="large"
          onClick={handleAdd}
        >
          TAMBAH
        </LoadingButton>
      </Grid>
    </Grid>
  );
};

export default ModalAddDepartment;
